// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__waLPv","inner":"Footer_inner__2GPGU"};